import { useContext, useState } from "react";
import { AuthContext } from "../../AuthContext/AuthContext";
import { ArmazemEntrada, ArmazemSaida, IArmazem } from "../../Interfaces/armazem/armazem";
import { post } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import { Button, Modal, TextField } from "@mui/material";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../Func_genericas/valores_estaticos";
import CloseIcon from "@mui/icons-material/Close";
import { loader } from "../../Func_genericas/loader";
import DeleteIcon from "@mui/icons-material/Delete";
import { CustomSelect, CustomTextFieldletrapequena } from "../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../Components/barra-de-ferramentas/BarraDeFerramentas";
import Switch from "react-switch";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";


interface I_aux {
    lista_artigos: ArmazemEntrada[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_lista_artigos: React.Dispatch<React.SetStateAction<ArmazemEntrada[]>>,
    set_lista_de_entradas: React.Dispatch<React.SetStateAction<ArmazemEntrada[]>>,
    lista_de_entradas: ArmazemEntrada[],
    lista_de_saidas_e_entradas: (ArmazemSaida | ArmazemEntrada)[],
    set_lista_de_saidas_e_entradas: React.Dispatch<React.SetStateAction<(ArmazemSaida | ArmazemEntrada)[]>>,
    armazem_selecionado: IArmazem | undefined,
}

// type ArmazemEntradaErrors = Partial<Record<keyof ArmazemEntrada, boolean>>;

export const ModalValidarDadosFatura: React.FC<I_aux> = ({
    lista_artigos,
    flag_open_modal,
    set_flag_open_modal,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_lista_artigos,
    lista_de_entradas,
    armazem_selecionado,
    set_lista_de_entradas,
    lista_de_saidas_e_entradas,
    set_lista_de_saidas_e_entradas,

}) => {
    const auth = useContext(AuthContext);


    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [errosArtigos, setErrosArtigos] = useState<Record<number, string[]>>({});
    const [mensagemResultadoBulk, setMensagemResultadoBulk] = useState("");
    const [artigosGuardados, setArtigosGuardados] = useState<any[]>([]);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState(false);

    const handleCloseDialog = () => {
        set_flag_open_modal(false);
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    const handleChangeProduto = <K extends keyof ArmazemEntrada>(
        index: number,
        campo: K,
        valor: ArmazemEntrada[K]
    ) => {
        set_lista_artigos((prev) =>
            prev.map((produto, i) =>
                i === index
                    ? {
                        ...produto,
                        [campo]: valor,
                    }
                    : produto
            )
        );

        // setErrosArtigos((prev) => ({
        //     ...prev,
        //     [index]: {
        //         ...prev[index],
        //         [campo]: false,
        //     },
        // }));
    };
    const handleDeleteProduto = (index: number) => {
        set_lista_artigos((prev) => prev.filter((_, i) => i !== index));
    };
    const converterNumeroFinal = (valor: any) => {
        if (valor === "" || valor === undefined || valor === null) return "";

        const valorNormalizado = String(valor).replace(",", ".");
        const numero = Number(valorNormalizado);

        return Number.isNaN(numero) ? "" : numero;
    };
    const transformarDadosArrayEmObj = (dadosArray: Record<string, any>[]) => {
        return dadosArray.reduce((acc: Record<string, any>, campoObj: Record<string, any>) => {
            const nomeCampo = Object.keys(campoObj)[0];
            const valorCampo = campoObj[nomeCampo];

            const tipoCampo = getTipoCampo(nomeCampo);

            acc[nomeCampo] = isCampoNumerico(tipoCampo)
                ? converterNumeroFinal(valorCampo)
                : valorCampo;

            return acc;
        }, {});
    };
    const prepararArtigosParaEnviar = (listaArtigos: any[]) => {
        return listaArtigos.map((artigo: any) => ({
            ...artigo,
            dados: transformarDadosArrayEmObj(artigo.dados),
        }));
    };

    const gerarChaveArtigo = (artigo: any) => {
        return JSON.stringify(artigo);
    };

    const artigoJaFoiGuardado = (artigo: any) => {
        const chaveArtigo = gerarChaveArtigo(artigo);

        return artigosGuardados.some((artigoGuardado: any) =>
            gerarChaveArtigo(artigoGuardado) === chaveArtigo
        );
    };
    const formatarErrosBulkComIndexOriginal = (
        erros: any[] = [],
        artigosParaEnviarComIndex: any[] = []
    ) => {
        const errosFormatados: Record<number, string[]> = {};

        erros.forEach((erro: any) => {
            const indexOriginal = artigosParaEnviarComIndex[erro.indice]?.indexOriginal;

            if (indexOriginal !== undefined) {
                errosFormatados[indexOriginal] = erro.erros || [];
            }
        });

        return errosFormatados;
    };
    const adicionarArtigosGuardados = (
        erros: any[] = [],
        artigosParaEnviarComIndex: any[] = []
    ) => {
        const indicesComErro = erros.map((erro: any) => erro.indice);

        const artigosCriadosComSucesso = artigosParaEnviarComIndex
            .filter((_: any, indexEnviado: number) => !indicesComErro.includes(indexEnviado))
            .map((item: any) => item.artigo);

        setArtigosGuardados((old: any[]) => {
            const novaLista = [...old];

            artigosCriadosComSucesso.forEach((artigo: any) => {
                const jaExiste = novaLista.some(
                    (artigoGuardado: any) =>
                        gerarChaveArtigo(artigoGuardado) === gerarChaveArtigo(artigo)
                );

                if (!jaExiste) {
                    novaLista.push(artigo);
                }
            });

            return novaLista;
        });
    };
    const handleSave = async () => {
        try {
            setIsLoading(true);
            setErrosArtigos({});
            setMensagemResultadoBulk("");

            console.log("Lista de artigos completa:", lista_artigos);

            const artigosParaEnviarComIndex = lista_artigos
                .map((artigo: any, indexOriginal: number) => ({
                    artigo,
                    indexOriginal,
                }))
                .filter((item: any) => !artigoJaFoiGuardado(item.artigo));

            if (artigosParaEnviarComIndex.length === 0) {
                setMessage("Todos os artigos já foram gravados.");
                setOpenSnackSuccess(true);
                set_flag_open_modal(false);
                return;
            }

            const artigosPreparados = prepararArtigosParaEnviar(
                artigosParaEnviarComIndex.map((item: any) => item.artigo)
            );

            console.log("Artigos a enviar:", artigosPreparados);

            let res = await post(
                auth.token.cookie_token,
                'armazens/' + armazem_selecionado?.id_armazem + '/entradas/bulk',
                {
                    entradas: artigosPreparados
                }
            );

            if (res.status === 201 || res.status === 200) {
                const resposta = res.data;

                const entradasCriadas = resposta?.entradas || [];
                const erros = resposta?.erros || [];

                const errosFormatados = formatarErrosBulkComIndexOriginal(
                    erros,
                    artigosParaEnviarComIndex
                );

                setErrosArtigos(errosFormatados);

                if (entradasCriadas.length > 0) {
                    set_lista_de_entradas((old: any[]) => [
                        ...old,
                        ...entradasCriadas
                    ]);

                    set_lista_de_saidas_e_entradas((old: any[]) => [
                        ...old,
                        ...entradasCriadas
                    ]);
                }

                adicionarArtigosGuardados(erros, artigosParaEnviarComIndex);

                if (erros.length > 0) {
                    setMensagemResultadoBulk(
                        `${resposta.criadas} de ${resposta.total} artigos foram gravados. Verifique os restantes artigos assinalados.`
                    );

                    setMessage(`${resposta.criadas} de ${resposta.total} artigos foram gravados.`);
                    setOpenSnackError(true);

                    set_flag_open_modal(true);
                    return;
                }

                setMensagemResultadoBulk("");
                setErrosArtigos({});

                setMessage("Gravado com sucesso!");
                setOpenSnackSuccess(true);

                set_flag_open_modal(false);
            } else {
                setMessage("Erro ao gravar!");
                setOpenSnackError(true);
            }

        } catch (error: any) {
            func_print("handleSave", error, true);

            const status = error?.response?.status;
            const respostaErro = error?.response?.data;

            if (status === 400 && respostaErro?.erros) {
                const artigosParaEnviarComIndex = lista_artigos
                    .map((artigo: any, indexOriginal: number) => ({
                        artigo,
                        indexOriginal,
                    }))
                    .filter((item: any) => !artigoJaFoiGuardado(item.artigo));

                const erros = respostaErro.erros || [];

                const errosFormatados = formatarErrosBulkComIndexOriginal(
                    erros,
                    artigosParaEnviarComIndex
                );

                setErrosArtigos(errosFormatados);

                setMensagemResultadoBulk(
                    respostaErro?.mensagem ||
                    "Nenhuma entrada foi criada. Verifique os artigos assinalados."
                );

                setMessage("Nenhuma entrada foi criada. Verifique os artigos assinalados.");
                setOpenSnackError(true);

                set_flag_open_modal(true);

                return;
            }

            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } finally {
            setIsLoading(false);
        }
    };
    // const validarArtigos = () => {
    //     const novosErros: Record<number, ArmazemEntradaErrors> = {};

    //     lista_artigos.forEach((item, index) => {
    //         novosErros[index] = {
    //             produto: !item.produto,
    //             fornecedor: !item.fornecedor,
    //             origem: !item.origem,
    //             destino: !item.destino,
    //             data: !item.data,
    //             quantidade: !item.quantidade,
    //             medida: !item.medida,
    //             consumo_energetico: !item.consumo_energetico,
    //             medida_energetico: !item.medida_energetico,
    //         };
    //     });

    //     setErrosArtigos(novosErros);

    //     const temErros = Object.values(novosErros).some((erros) =>
    //         Object.values(erros).some(Boolean)
    //     );

    //     return !temErros;
    // };


    const atualizarCampoArtigo = (
        indexArtigo: number,
        indexCampo: number,
        nomeCampo: string,
        novoValor: any
    ) => {
        set_lista_artigos((prev: any[]) =>
            prev.map((artigo, i) => {
                if (i !== indexArtigo) return artigo;

                return {
                    ...artigo,
                    dados: artigo.dados.map((campoObj: Record<string, any>, j: number) => {
                        if (j !== indexCampo) return campoObj;

                        return {
                            [nomeCampo]: novoValor,
                        };
                    }),
                };
            })
        );
    };


    const getTipoCampo = (nomeCampo: string) => {
        const campo = armazem_selecionado?.schema_custom?.campos?.find(
            (el: any) => el.nome === nomeCampo
        );

        return campo?.tipo ?? "string";
    };
    const getOpcoesCampo = (nomeCampo: string) => {
        const campo = armazem_selecionado?.schema_custom?.campos?.find(
            (el: any) => el.nome === nomeCampo
        );

        return campo?.opcoes || [];
    };
   
    const isCampoNumerico = (tipo: string) => {
        return ["number", "integer", "float"].includes(tipo);
    };

    const isValorNumericoValido = (valor: string) => {
        // permite vazio
        if (valor === "") return true;

        // permite números com ponto ou vírgula decimal
        // exemplos válidos: 1, 1.5, 1,5, 0.5, 0,5, -1, -1.5, -1,5
        return /^-?\d*([.,]\d*)?$/.test(valor);
    };

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundColor: 'white',
            width: '90%',
            height: '80%',
            flexDirection: 'column',
            borderRadius: 5,
        }}>
            <div style={{
                width: '100%',
                display: "flex",
                alignItems: 'space-between',
                justifyContent: 'flex-end',
                flex: 0.1,
            }}>

                <div
                    style={{
                        color: cores.cor1,
                        display: "flex",
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        fontWeight: 'bold',
                        fontSize: 25,
                        paddingLeft: 10,
                        width: '100%',
                        fontFamily: "candara"
                    }}>

                    Lista de Artigos Registados na Fatura

                </div>
                <div style={{
                    width: '100%',
                    display: "flex",
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                }}>
                    <Button
                        sx={{ color: "#AAAAAA" }}
                        size="large"
                        onClick={() => {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                        }}
                    >
                        <CloseIcon />
                    </Button>
                </div>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>


                        <div style={{
                            flex: 0.8,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            width: '100%',
                            overflowY: 'scroll',
                            scrollbarWidth: 'thin',
                            height: '100%',
                            paddingBottom: 10
                        }}
                        >
                            <div
                                style={{
                                    width: "96%",
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: 8,
                                }}
                            >
                                {mensagemResultadoBulk && (
                                    <div
                                        style={{
                                            backgroundColor: "#fff3cd",
                                            color: "#664d03",
                                            border: "1px solid #ffecb5",
                                            borderRadius: 6,
                                            padding: "10px 12px",
                                            marginBottom: 16,
                                            fontSize: 14,
                                            fontFamily: "candara",
                                        }}
                                    >
                                        {mensagemResultadoBulk}
                                    </div>
                                )}
                                {lista_artigos.map((item, index) => {

                                    const errosDoArtigo = errosArtigos[index] || [];
                                    const artigoTemErro = errosDoArtigo.length > 0;
                                    const artigoJaGuardado = artigoJaFoiGuardado(item);
                                    return (
                                        <div
                                            key={index}
                                            // style={{
                                            //     border: "1px solid #ddd",
                                            //     borderRadius: 6,
                                            //     padding: 10,
                                            //     backgroundColor: "#fafafa",
                                            //     marginBottom: 12,
                                            // }}

                                            style={{
                                                border: artigoTemErro
                                                    ? "1px solid #dc3545"
                                                    : artigoJaGuardado
                                                        ? "1px solid #198754"
                                                        : "1px solid #ddd",
                                                borderRadius: 6,
                                                padding: 10,
                                                backgroundColor: artigoTemErro
                                                    ? "#fff5f5"
                                                    : artigoJaGuardado
                                                        ? "#f0fff4"
                                                        : "#fafafa",
                                                marginBottom: 12,
                                                opacity: artigoJaGuardado ? 0.75 : 1,
                                            }}
                                        >
                                            {/* Cabeçalho do artigo */}

                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    // marginBottom: 4,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontWeight: "bold",
                                                        color: cores.cor1,
                                                        fontFamily: "candara",
                                                        fontSize: 15,
                                                    }}
                                                >
                                                    Artigo {index + 1}
                                                    {artigoJaGuardado && (
                                                        <span style={{ marginLeft: 8, fontSize: 13 }}>
                                                            — gravado
                                                        </span>
                                                    )}

                                                    {artigoTemErro && (
                                                        <span style={{ marginLeft: 8, fontSize: 13 }}>
                                                            — com erro
                                                        </span>
                                                    )}

                                                </div>

                                                <Button
                                                    size="small"
                                                    onClick={() => handleDeleteProduto(index)}
                                                    sx={{
                                                        minWidth: 0,
                                                        color: "#b00020",
                                                        padding: "4px",
                                                    }}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </Button>
                                            </div>

                                            {/* Campos */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',

                                                }}
                                            >

                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    gap: 8,

                                                }}>
                                                    <CustomTextFieldletrapequena
                                                        size="small"
                                                        label="Registado por"
                                                        name="registado_por"
                                                        disabled={artigoJaGuardado ? true : false}
                                                        value={item.registado_por || ""}
                                                        onChange={(e: any) =>
                                                            handleChangeProduto(index, "registado_por", e.target.value)
                                                        }
                                                        // error={!!errosArtigos[index]?.produto}
                                                        // helperText={errosArtigos[index]?.produto ? "Preencha este campo" : ""}
                                                        sx={{
                                                            display: 'flex',
                                                            flex: 0.33
                                                        }}
                                                    />

                                                    <CustomTextFieldletrapequena
                                                        label="Doc. Nº"
                                                        name="doc"
                                                        size="small"
                                                        disabled={artigoJaGuardado ? true : false}

                                                        value={item.documento_ref || ""}
                                                        onChange={(e: any) =>
                                                            handleChangeProduto(index, "documento_ref", e.target.value)
                                                        }
                                                        sx={{
                                                            display: 'flex',
                                                            flex: 0.33
                                                        }}
                                                    />
                                                    <TextField
                                                        label="Data"
                                                        type="date"
                                                        variant="filled"
                                                        size="small"
                                                        disabled={artigoJaGuardado ? true : false}

                                                        value={item.data_entrada || ""}
                                                        onChange={(e) =>
                                                            handleChangeProduto(index, "data_entrada", e.target.value)
                                                        }
                                                        sx={{
                                                            display: 'flex',
                                                            flex: 0.33,
                                                            marginTop: 2
                                                        }}
                                                    // error={!!errosArtigos[index]?.data}
                                                    // helperText={errosArtigos[index]?.data ? "Preencha este campo" : ""}
                                                    />


                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    gap: 8,
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',



                                                }}>


                                                    <CustomTextFieldletrapequena
                                                        label="Qtd."
                                                        name="quantidade_entrada"
                                                        size="small"
                                                        disabled={artigoJaGuardado ? true : false}

                                                        value={item.quantidade_entrada || ""}
                                                        onChange={(e: any) =>
                                                            handleChangeProduto(index, "quantidade_entrada", e.target.value)
                                                        }
                                                        sx={{
                                                            display: 'flex',
                                                            flex: 0.33
                                                        }}
                                                    // error={!!errosArtigos[index]?.quantidade}
                                                    // helperText={
                                                    //     errosArtigos[index]?.quantidade ? "Insira apenas números" : ""
                                                    // }
                                                    />
                                                    <CustomTextFieldletrapequena
                                                        label="Unidade"
                                                        name="doc"
                                                        size="small"
                                                        disabled={artigoJaGuardado ? true : false}

                                                        value={item.unidade || ""}
                                                        onChange={(e: any) =>
                                                            handleChangeProduto(index, "unidade", e.target.value)
                                                        }
                                                        sx={{
                                                            display: 'flex',
                                                            flex: 0.33
                                                        }}
                                                    />
                                                    <CustomTextFieldletrapequena
                                                        label="Observações"
                                                        size="small"
                                                        name="observacoes"
                                                        disabled={artigoJaGuardado ? true : false}

                                                        value={item.observacoes || ""}
                                                        onChange={(e: any) =>
                                                            handleChangeProduto(index, "observacoes", e.target.value)
                                                        }
                                                        sx={{
                                                            display: 'flex',
                                                            flex: 0.33
                                                        }}
                                                    />
                                                </div>
                                                {/* Campos dinâmicos dos dados */}
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "repeat(3, 1fr)",
                                                        columnGap: 12,
                                                        rowGap: 12,
                                                    }}
                                                >


                                                    {item.dados.map((campoObj: Record<string, any>, indexCampo: number) => {
                                                        const nomeCampo = Object.keys(campoObj)[0];
                                                        const valorCampo = campoObj[nomeCampo];
                                                        const tipoCampo = getTipoCampo(nomeCampo);
                                                        const opcoesCampo = getOpcoesCampo(nomeCampo);
                                                        const mensagemErroCampo = errosDoArtigo.find((erro: string) =>
                                                            erro.includes(`'${nomeCampo}'`)
                                                        );

                                                        const campoTemErro = Boolean(mensagemErroCampo);
                                                        if (tipoCampo === "boolean") {


                                                            return (
                                                                <div key={indexCampo} className="flex flex-col gap-2">
                                                                    <span className="text-sm text-gray-600">{nomeCampo}</span>

                                                                    <Switch
                                                                        height={22}
                                                                        width={44}
                                                                        onColor={cores.cor1}
                                                                        offColor="#e5e7eb"
                                                                        disabled={artigoJaGuardado ? true : false}

                                                                        onChange={(checked: boolean) => {
                                                                            atualizarCampoArtigo(
                                                                                index,
                                                                                indexCampo,
                                                                                nomeCampo,
                                                                                checked
                                                                            );
                                                                        }}
                                                                        checked={valorCampo === undefined ? false : Boolean(valorCampo)}
                                                                    />
                                                                </div>
                                                            );
                                                        } else if (tipoCampo === "select") {
                                                            return (
                                                                <div key={indexCampo}>
                                                                    <CustomSelect
                                                                        value={valorCampo === undefined || valorCampo === null ? "" : String(valorCampo)}
                                                                        onChange={(event: any) => {

                                                                            atualizarCampoArtigo(
                                                                                index,
                                                                                indexCampo,
                                                                                nomeCampo,
                                                                                event.target.value
                                                                            )
                                                                        }}
                                                                        options={opcoesCampo.length === 0 ? [] : opcoesCampo}
                                                                        label={nomeCampo}
                                                                        name={nomeCampo}
                                                                        disabled={artigoJaGuardado ? true : false}
                                                                    />

                                                                    {campoTemErro && (
                                                                        <span style={{ color: "#dc3545", fontSize: 12 }}>
                                                                            {mensagemErroCampo}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            );
                                                        } else
                                                            return (
                                                                <CustomTextFieldletrapequena
                                                                    key={indexCampo}
                                                                    label={nomeCampo}
                                                                    name={nomeCampo}
                                                                    size="small"
                                                                    type={isCampoNumerico(tipoCampo) ? "number" : "text"}
                                                                    value={valorCampo ?? ""}
                                                                    error={campoTemErro}
                                                                    disabled={artigoJaGuardado ? true : false}

                                                                    helperText={campoTemErro ? mensagemErroCampo : ""}

                                                                    onChange={(e: any) => {
                                                                        const valorDigitado = e.target.value;

                                                                        if (isCampoNumerico(tipoCampo)) {
                                                                            if (!isValorNumericoValido(valorDigitado)) return;

                                                                            atualizarCampoArtigo(
                                                                                index,
                                                                                indexCampo,
                                                                                nomeCampo,
                                                                                valorDigitado
                                                                            );

                                                                            return;
                                                                        }

                                                                        atualizarCampoArtigo(
                                                                            index,
                                                                            indexCampo,
                                                                            nomeCampo,
                                                                            valorDigitado
                                                                        );
                                                                    }}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}

                                                                />
                                                            )
                                                    })}

                                                </div>


                                            </div>
                                        </div>
                                    )
                                })}
                            </div>


                        </div>
                    </>
            }
            <div style={{
                flex: 0.1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                flexDirection: 'row',
                width: '90%',

            }}>
                <BarraDeFerramentas
                    mostrarBotaoGravar
                    // textoBotaoNovo="Novo Registo"
                    aoClicarGravar={() => {
                        handleSave()

                    }}
                />
            </div>

            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </div>


    </Modal>)

}
